;(function() {
  'use strict'

  answersToWordsFilter.$inject = ["stopWords"];
  angular
    .module('core.filters')
    /**
     * @name stopWords
     * @description list of words that should not be used for word cloud
     */
    .constant('stopWords', [
      'a',
      'able',
      'about',
      'across',
      'after',
      'all',
      'almost',
      'also',
      'am',
      'among',
      'an',
      'and',
      'any',
      'are',
      'as',
      'at',
      'be',
      'because',
      'been',
      'but',
      'by',
      'can',
      'cannot',
      'could',
      'dear',
      'did',
      'do',
      'does',
      'either',
      'else',
      'ever',
      'every',
      'for',
      'from',
      'get',
      'got',
      'had',
      'has',
      'have',
      'he',
      'her',
      'hers',
      'him',
      'his',
      'how',
      'however',
      'i',
      'if',
      'in',
      'into',
      'is',
      'it',
      'its',
      'just',
      'least',
      'let',
      'like',
      'likely',
      'may',
      'me',
      'might',
      'most',
      'must',
      'my',
      'neither',
      'no',
      'nor',
      'not',
      'of',
      'off',
      'often',
      'on',
      'only',
      'or',
      'other',
      'our',
      'own',
      'rather',
      'said',
      'say',
      'says',
      'she',
      'should',
      'since',
      'so',
      'some',
      'than',
      'that',
      'the',
      'their',
      'them',
      'then',
      'there',
      'these',
      'they',
      'this',
      'tis',
      'to',
      'too',
      'twas',
      'us',
      'wants',
      'was',
      'we',
      'were',
      'what',
      'when',
      'where',
      'which',
      'while',
      'who',
      'whom',
      'why',
      'will',
      'with',
      'would',
      'yet',
      'you',
      'your',
    ])
    .filter('answersToWords', answersToWordsFilter)

  /**
   * @name toWords
   * @description filters interactions into an object to be used by the wordCloud directive
   *
   * @param {Array} stopWords array of interactions
   * @returns {Array} array of unique words with their respective word count
   *
   * @ngInject
   */
  function answersToWordsFilter(stopWords) {
    return function(input, limit, ignoreWords) {
      // var oddCharsRegex = /[0-9\.,-\/#!$@%\^&\*\";:{}=\-_`~()?]/g;
      var oddCharsRegex = /[\\.,+|<>\/[\]#!$@%\^&\*\";:{}=\-_`~()?]/g
      var multispaceRegex = /\s{2,}/g
      var tabspaceRegex = /[ \t]+$/g
      var carriageReturnRegex = /[\n\r]/g

      limit = limit || 50

      var frequencies = {}
      var stopWordsHash = {}
      var output

      // add ignore words to stop words
      stopWords = stopWords.concat(ignoreWords)

      // parse stopwords to associative-array / hash object for O(1) lookup
      for (var i = 0, len = stopWords.length; i < len; i++) {
        stopWordsHash[stopWords[i]] = true
      }

      // process interactions
      _.forEach(input, function(answer) {
        processAnswer(answer)
      })

      // convert to array
      output = _.map(frequencies, function(value, key) {
        value.word = key
        return value
      })

      // sort and limit
      output = _.sortBy(output, function(word) {
        return -word.total
      }).slice(0, limit)

      return output

      /**
       * Clean unwanted characters
       */
      function cleanString(string) {
        return string
          .replace(oddCharsRegex, '')
          .replace(carriageReturnRegex, ' ')
          .replace(multispaceRegex, ' ')
          .replace(tabspaceRegex, ' ')
      }

      /**
       * Process text answer
       */
      function processAnswer(answer) {
        var words = []
        if (_.isNumber(answer.text)) {
          words.push(answer.text.toString())
        } else {
          words = words.concat(cleanString(answer.text).split(' '))
        }
        addWords(words, answer.questionId)
      }

      /**
       * Add words to the frequency associative array / hash
       */
      function addWords(words, type) {
        var wordCounted = {}
        for (var i = 0, len = words.length; i < len; i++) {
          var word = words[i].toLowerCase()

          // if not a stop word, add it to frequencies
          if (!stopWordsHash[word]) {
            frequencies[word] = frequencies[word] || {}
            frequencies[word][type] = frequencies[word][type] || 0
            frequencies[word].total = frequencies[word].total || 0
            frequencies[word].total++
            if (!wordCounted[word]) {
              frequencies[word][type]++
              wordCounted[word] = true
            }
          }
        }
      }
    }
  }
})()
